import { useTranslation } from "react-i18next";
import TaskList from "../common/TaskList";
import { useDispatch } from "../providers/DispatchProvider";
import { Button, Grid, Stack, Typography } from "@mui/material";
import DispatchCompactToolbar from "../common/DispatchCompactToolbar";


export default function MobileDispatchView() {
  const { t } = useTranslation();
  const { showLoading, filteredActiveTasks, activeTasks, resetFilter, orderTasksBy } = useDispatch();
  const showClearFilters = activeTasks.length > filteredActiveTasks.length

  return (
    <Grid item xs={12}>
      <Stack spacing={1}>
        <DispatchCompactToolbar />

        <Typography variant="body" color="textSecondary">
          {showClearFilters ? `Viser ${filteredActiveTasks.length} av ${activeTasks.length}` : `${activeTasks.length} totalt`}
          {showClearFilters ? <Button color="info" onClick={resetFilter}>(nullstill filter)</Button> : null}
        </Typography>

        <TaskList
          cards
          orderTasksBy={orderTasksBy}
          tasks={filteredActiveTasks}
          showLoading={showLoading}
          emptyStateTitle={t("dispatch:activeTasks:emptyStateTitle")}
          emptyStateDescription={t("dispatch:activeTasks:emptyStateDescription")}
          emptyStateFilteredDescription={t("dispatch:activeTasks:emptyStateFilteredDescription")}
        />
      </Stack>
    </Grid>
  );
}